import React from 'react';
import { MapPin, Mail, Phone, Building } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_55daa337-b083-4bba-81d0-04d8a52c32f6/artifacts/6cgwa6q5_DODIPA_logo_380x380.jpg";

const About = () => {
  return (
    <section id="chi-siamo" data-testid="about-section" className="py-20 pb-28 md:py-32 relative">
      {/* Background */}
      <div className="absolute top-1/2 right-0 w-96 h-96 bg-[#C14B7E]/5 rounded-full blur-3xl -translate-y-1/2" />

      <div className="container-custom relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left - Company Info */}
          <div>
            <span className="text-sm uppercase tracking-widest font-bold text-[#C14B7E] mb-4 block">
              Chi Siamo
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-semibold text-white mb-6">
              DODIPA
            </h2>
            <p className="text-white/60 text-base md:text-lg leading-relaxed mb-8">
              DODIPA è un marchio concesso in uso esclusivo a <strong className="text-white">F&P IDEA S.R.L.S.</strong>, 
              società specializzata in servizi di intermediazione per l'energia elettrica e il gas naturale.
              Da diversi anni accompagniamo le aziende italiane nel percorso di ottimizzazione energetica 
              e nell'accesso a finanziamenti agevolati.
            </p>
            <p className="text-white/60 text-base md:text-lg leading-relaxed mb-10">
              La nostra missione è semplice: aiutare le imprese energivore a trasformare 
              i costi energetici in opportunità di crescita, attraverso consulenza strategica, 
              soluzioni tecnologiche innovative e un network consolidato di partner finanziari.
            </p>

            {/* Company Details */}
            <div className="space-y-4">
              <div className="flex items-start gap-4" data-testid="about-address">
                <div className="w-10 h-10 rounded-lg bg-[#5CBDB0]/10 flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-5 h-5 text-[#5CBDB0]" />
                </div>
                <div>
                  <div className="text-white font-medium">Sede Legale</div>
                  <div className="text-white/50 text-sm">Corso Pietro Giannone 1/A, 71121 Foggia (FG)</div>
                </div>
              </div>

              <div className="flex items-start gap-4" data-testid="about-vat">
                <div className="w-10 h-10 rounded-lg bg-[#F5A547]/10 flex items-center justify-center flex-shrink-0">
                  <Building className="w-5 h-5 text-[#F5A547]" />
                </div>
                <div>
                  <div className="text-white font-medium">Partita IVA</div>
                  <div className="text-white/50 text-sm">04328400710</div>
                </div>
              </div>

              <div className="flex items-start gap-4" data-testid="about-email">
                <div className="w-10 h-10 rounded-lg bg-[#C14B7E]/10 flex items-center justify-center flex-shrink-0">
                  <Mail className="w-5 h-5 text-[#C14B7E]" />
                </div>
                <div>
                  <div className="text-white font-medium">PEC</div>
                  <div className="text-white/50 text-sm">fpidea@pec.it</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right - Visual */}
          <div className="relative">
            <div className="glass-card rounded-3xl p-10 relative overflow-hidden">
              {/* Decorative elements */}
              <div className="absolute -top-10 -right-10 w-40 h-40 bg-[#5CBDB0]/10 rounded-full blur-3xl" />
              <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-[#F5A547]/10 rounded-full blur-3xl" />

              <div className="relative z-10">
                {/* Logo */}
                <div className="flex justify-center mb-8">
                  <img 
                    src={LOGO_URL} 
                    alt="DODIPA Logo" 
                    className="w-32 h-32 rounded-2xl object-contain bg-white p-2"
                    data-testid="about-logo"
                  />
                </div>

                {/* Values */}
                <div className="grid grid-cols-2 gap-3 sm:gap-4">
                  <div className="text-center p-3 sm:p-4 rounded-xl bg-white/5">
                    <div className="font-heading text-lg sm:text-2xl font-bold text-[#5CBDB0]">Esperienza</div>
                    <div className="text-white/50 text-[10px] sm:text-xs uppercase tracking-wider mt-1">Pluriennale</div>
                  </div>
                  <div className="text-center p-3 sm:p-4 rounded-xl bg-white/5">
                    <div className="font-heading text-base sm:text-2xl font-bold text-[#F5A547]">Professionalità</div>
                    <div className="text-white/50 text-[10px] sm:text-xs uppercase tracking-wider mt-1">Certificata</div>
                  </div>
                </div>

                <div className="mt-6 p-4 rounded-xl bg-white/5">
                  <div className="text-white/70 text-sm text-center">
                    <span className="text-white font-medium">La nostra missione:</span>
                    <br />
                    Trasformare l'energia in opportunità di crescita per la tua azienda
                  </div>
                </div>

                {/* Certifications placeholder */}
                <div className="mt-6 pt-6 border-t border-white/10 text-center">
                  <div className="text-white/40 text-xs uppercase tracking-wider mb-3">Iscrizione</div>
                  <div className="text-white/70 text-sm">
                    Camera di Commercio di Foggia
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
